$(document).ready ->
  file_preview = $(".upload-marker img")
  video_preview = $(".play-marker-video")
  
  AUGMENTED_REALITY_PAGE_FILE_LIMITS = $('#augmented_reality_page_file_limits').val() && JSON.parse($('#augmented_reality_page_file_limits').val())
  
  $(".file-marker").change (event) ->
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    
    return if fileSizeNotInLimit(file,event,".edit-banner-modal",AUGMENTED_REALITY_PAGE_FILE_LIMITS["marker_image"])

    reader = new FileReader()

    reader.onload = (e) ->
      image_base64 = e.target.result
      file_preview.attr "src", image_base64
      
      return
    reader.readAsDataURL file

    return
    
  $(".new-marker-video").change (event) ->
    $(".play-marker-video").css("display", "block")
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    
    reader = new FileReader()

    reader.onload = (e) ->
      image_base64 = e.target.result
      image_base64 = image_base64.replace("quicktime","mp4")
      video_preview.attr "src", image_base64
      
      return
    reader.readAsDataURL file

    return    
    
  $(".edit-marker-video").change (event) ->
    input = $(event.currentTarget)
    file = input[0].files[0]
    return unless !!file
    
    reader = new FileReader()

    reader.onload = (e) ->
      image_base64 = e.target.result
      image_base64 = image_base64.replace("quicktime","mp4")
      video_preview.attr "src", image_base64
      $(".thumbnail-option").find('video').attr('poster', '')
      
      return
    reader.readAsDataURL file

    return 
  return